import VueScrollTo from 'vue-scrollto'
import config from '../../lib/config'
const {SCROLL_OFFSET: scrollOffset} = config

export default {
  methods: {
    scrollToTop(duration, options) {
      this.scrollTo('.supercharged-entertainment-container', duration, options)
    },
    scrollTo(element, duration, options) {
      options = options || {}
      options.offset = options.offset || scrollOffset
      VueScrollTo.scrollTo(element, duration, options)
    },
    scrollToBodyTop(duration, options) {
      this.scrollTo('body', duration, options)
    },
  },

}

